<template>
	<div class="project-casee-list-wrapper">
		<EmptyPage 
			v-if="projectCaseList.length === 0" 
			:height="480" 
			:loading="loading" />
		<div v-else>
			<div class="project-casee-list">
				<div 
					class="project-casee-list-item" 
					v-for="(item, index) in projectCaseList" 
					:key="index">
					<ServiceCard 
						:data="item" 
						@set-project-case="setProjectCase" 
						:user="user" />
				</div>
			</div>
			<div 
				class="loading" 
				v-show="scrollLoading">
				<i class="el-icon-loading"></i>
			</div>
			<!-- 分页 -->
			<div class="project-casee-list__pagination">
				<el-pagination
					background
					layout="prev, pager, next"
					:hide-on-single-page="true"
					:page-size="pageSize"
					:current-page="pageNum"
					:total="total"
					@current-change="handlePageChange">
				</el-pagination>
			</div>
		</div>
		<!-- <material-detail v-if="material" :material.sync="material" @updateMaterialList="updateMaterialList"></material-detail> -->
	</div>
</template>

<script>
import { mapState } from 'vuex';
import { getProjectCaseList, getProjectCasePayed, getProjectCaseByAuthor, getMyCollectProjectCase } from '@/api/projectCase';
import { openWindow } from '@/utils/utils';
import ServiceCard from './ServiceCard';
import EmptyPage from '@/components/EmptyPage';
export default {
	name: 'ProjectCaseList',
    components: {
		ServiceCard,
		EmptyPage
    },
    props: {
		// 各项标签
        tab: {
            type: Object,
            default: () => {}
		},
		// 素材类型【1：免费素材】
		materialType: {
			type: String,
			default: '1'
		},
		// 素材归属用户
		user: {
			type: Object,
			required: false
		},
		// 是否是已收藏素材
		collected: {
			type: Boolean,
			required: false
		},
		type: {
			type: [String, Number],
			required: false
		},

		author: {
			type: Boolean,
			required: false,
			default: false
		}
	},
	inject:['backTop'],
	data() {
		return {
			loading: false,
			scrollLoading: false,
			total: 0,
			pageSize: 40,
			pageNum: 1,
			pages: 1,
			// 源码列表
			projectCaseList: [],
			// 需要显示详情的源码
			material: null,
		}
	},
    computed: {
        ...mapState('app', ['scrollStatus']),
		...mapState("user", ["userInfo"]),
    },
	watch: {
		tab: {
			deep: true,
            immediate:true,
			handler(newVal, oldVal) {
				// Object.assign(this.$data, this.$options.data.call(this));
				this.projectCaseList = [];
				this.total = 0;
				this.pageSize = 40;
				// this.pageNum = sessionStorage.getItem(this.$route.path) || 1;
				this.pageNum = 1;
				this.pages = 1;
				// if((this.$route.params.type || this.$route.params.subType) && !newVal.categoryOne) {
				// 	return
				// }
				if (!this.loading){
					this.getProjectCase();
				}
			}
		},
		// scrollStatus() {
		// 	if (!this.user && !this.scrollLoading) {
		// 		this.scroll();
		// 	}
		// },
		type:{
			immediate:true,
			handler(newVal, oldVal) {
				this.projectCaseList = [];
				this.total = 0;
				this.pageSize = 40;
				this.pageNum =  1;
				// this.pageNum = sessionStorage.getItem(this.$route.path) || 1;
				this.pages = 1;
				if (!this.loading && newVal){
					this.getProjectCase();
				}
			}
		}
		// material: {
		// 	deep: true,
		// 	handler(val) {
		// 		if (!val) {
		// 			this.pageNum = 1;
		// 			this.getProjectCase();
		// 		}
		// 	}
		// },
	},
	created() {
		// this.pageNum = sessionStorage.getItem(this.$route.path) || 1
		// this.getProjectCase();
	},
	methods: {
		handlePageChange(pageNum) {
			sessionStorage.setItem(this.$route.path,pageNum)
            this.pageNum = pageNum;
            this.backTop();
            this.getProjectCase();
        },
        // 无限滚动
        scroll() {
            if (this.pageNum > 100) return;
            if (this.pageNum >= this.pages) return;
            this.scrollLoading = true;
            this.pageNum++;
            this.getProjectCase();
        },
		// 获取素材
		getProjectCase() {
			this.loading = true;
			let queryAjax;
					
			switch (this.type) {
				case 'order':
					queryAjax = getProjectCasePayed
					break;

				case 'collection':
					queryAjax = getMyCollectProjectCase
					break;

				case 'author':
					queryAjax = getProjectCaseByAuthor
					break;

				default:
					queryAjax = getProjectCaseList
					break;
			}

			let params = {
				pageNum: this.pageNum,
				pageSize: this.pageSize,
			}
			if (['order', 'collection'].includes(this.type)) {
				params.userId = this.userInfo.id
			} else {
				params = {
					...params,
					...{
						author: (this.tab || {}).author || '',
						categoryOne: this.tab.categoryOne === 'null' ? '' : this.tab.categoryOne || '',
						categoryTwo: this.tab.categoryTwo === 'o' ? '' : this.tab.categoryTwo || '',
						techId: this.tab.techId === 'o' ? '' : this.tab.techId || '',
					}
				}
			}

			queryAjax(params).then(({ data,total }) => {
				console.log('data: ', data);
				let _data = data
				if (['order', 'collection', 'author'].includes(this.type)) {
					_data = data.result
				}
				if (this.scrollLoading) {
					this.projectCaseList.push(..._data);
				} else {
					this.projectCaseList = _data;
				}
				this.total = total || _data.length;
				// this.pages = _data.pages || 1;
				this.projectCaseList.forEach(item => {
					item.formatList = item.categoryList&& item.categoryList.length ? (item.categoryList[0].techChildList || []).map(subItme => ({name:(subItme.categoryName||'').toLowerCase()})) : []
				})
				
			}).finally(() => {
				this.loading = false;
				this.scrollLoading = false;
			});
		},
		setProjectCase(id) {
			if (!id) {
				return;
			}
			openWindow(`/#/projectCase/detail/${id}`)
		}
	}
}
</script>

<style lang="scss" scoped>
.project-casee-list {

    &-item {
        display: inline-block;
        margin-right: 20px;
        margin-top: 20px;
        width: 300px;
    }
	&__pagination {
        margin-top: 45px;
		padding-bottom: 30px;
        text-align: center;
    }
}
.loading {
    margin: 20px 0;
    text-align: center;
    font-size: 32px;
}
@include mq($small) {
    .project-casee-list {
        padding-top: 15px;
        &-item {
            // margin-right: 10px;
            // margin-top: 10px;
			width: 280px;
        }
    }
}
</style>
